import * as z from 'zod';

import { statusMutationSchema } from '@/_schemas/status-input';

import { tcTemplateQuerySchema } from './tc-template-query-schema';

export const tcTemplateUpdateSchema = tcTemplateQuerySchema
  .omit({
    status: true,
    terms_conditions: true,
    agreements_count: true,
  })
  .extend({
    status: statusMutationSchema,
    terms_conditions: z.array(z.object({ id: z.number(), sort_order: z.number(), ctg_id: z.number() })),
  });

export type TcTemplateUpdateSchema = z.infer<typeof tcTemplateUpdateSchema>;

export const tcTemplateCreateSchema = tcTemplateUpdateSchema.omit({
  id: true,
});

export type TcTemplateCreateSchema = z.infer<typeof tcTemplateCreateSchema>;
